import { useMutation, useQueryClient } from '@tanstack/react-query';
import axiosInstance from '../../axiosConfig';

const createMapping = async (body) => {
  const path = '/mappings/';
  try {
    const response = await axiosInstance.post(path, body);
    return response.data;
  } catch (error) {
    console.error('Create Mapping API error:', error);
    throw error;
  }
};

export const useCreateMapping = (options = {}) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: createMapping,
    onSuccess: (data, variables) => {
      // Invalide le cache pour forcer un refetch des données
      queryClient.invalidateQueries({ queryKey: ['mappings'] });
      queryClient.invalidateQueries({ queryKey: ['mpCatalogueAssociations'] });

      // Appelle le callback onSuccess personnalisé s'il existe
      options.onSuccess?.(data, variables);
    },
    onError: (error, variables) => {
      console.error('Mutation error:', error);
      options.onError?.(error, variables);
    },
    ...options,
  });

  return {
    createMapping: mutation.mutateAsync,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    error: mutation.error,
    data: mutation.data,
  };
};
